import PropTypes from "prop-types";
import React, { useState } from "react";
import galleryTemplate from "templates/modules/product/product_image_gallery.jinja";
import Baustein from "web/react/components/baustein/baustein";
import FullscreenGallery from "web/react/components/product-gallery/product-gallery-fullscreen/product-gallery-fullscreen";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import { ProductPropType } from "web/types/product";
import { ProductCardPropType } from "web/types/product-card";
import styles from "./oos-image.css";

import "web/script/components/image-gallery";


function OOSImage({ product, relatedProducts }) {
    let [openGallery, setOpenGallery] = useState(false);

    let bausteinGallery = (
        <Baustein
            template={galleryTemplate}
            args={{
                modifier: "vertical-thumbnails",
                product_image_gallery: {
                    product_id: product.product_id,
                    buy_option: null, // Always null
                    images: product.images,
                    designer: "", // Never used
                    designer_link: "", // Never used
                    images_count: product.images.length,
                    retailer_name: "", // Never used
                    view_similar_enabled: false, // Always false
                    preventMainImageChange: true,
                },
            }}
        />
    );

    return (
        <div className={styles.image}>
            {bausteinGallery}
            <button
                aria-label={
                    gettext(
                        "product_image_gallery.invisible_text_for_accessibility.view_fullscreen"
                    ) // View Fullscreen
                }
                className={styles.smallScreenImage}
                onClick={() => setOpenGallery(true)}
            >
                <img src={product.images[0].large_url} alt={product.images[0].alt_text} />
                <div className={styles.icon}>
                    <SVGIcon name="expand" />
                </div>
            </button>
            <FullscreenGallery
                analyticsAction={"mobile_gallery"}
                images={product.images}
                relatedProducts={relatedProducts}
                isOpen={openGallery}
                onClose={() => setOpenGallery(false)}
            />
        </div>
    );
}

export default OOSImage;

OOSImage.propTypes = {
    product: ProductPropType,
    relatedProducts: PropTypes.arrayOf(ProductCardPropType).isRequired,
};
